import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  actions?: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({ children, className = '', title, actions }) => {
  return (
    <div className={`bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden ${className}`}>
      {(title || actions) && (
        <div className="flex flex-col gap-3 border-b border-gray-100 bg-gray-50/50 px-4 py-4 dark:border-gray-700 dark:bg-gray-800/50 sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-5">
          {title && <h3 className="text-base font-bold tracking-tight text-gray-900 dark:text-white sm:text-lg">{title}</h3>}
          {actions && <div className="sm:flex-shrink-0">{actions}</div>}
        </div>
      )}
      <div className="p-4 sm:p-6">
        {children}
      </div>
    </div>
  );
};
